export const providerStatusClass = (status) => {
  const v = String(status || '').toLowerCase();
  if (v.includes('complet') || v.includes('done') || v.includes('success')) return 'status-completed';
  if (v.includes('cancel') || v.includes('refund')) return 'status-cancelled';
  if (v.includes('partial')) return 'status-partial';
  if (v.includes('error') || v.includes('fail') || v.includes('reject')) return 'status-cancelled';
  if (v.includes('progress') || v.includes('process')) return 'status-processing';
  return 'status-pending';
};

export const parseProviderResponse = (o) => {
  const pr = o.provider_response;
  if (pr && typeof pr === 'string') {
    try {
      return JSON.parse(pr);
    } catch {
      return null;
    }
  }
  return pr && typeof pr === 'object' ? pr : null;
};
